// @flow
import React, { Children, type Node } from 'react';
import classnames from 'classnames';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

type Props = {
  children: Node,
  className?: string,
  color: Colors,
  hasSubItems?: boolean,
  isActive?: boolean,
  link: {
    trackingData?: TrackingData,
    url: string,
  },
};

export function NavigationLargeFirstLevelItem({
  children,
  className,
  color,
  hasSubItems,
  isActive,
  link,
}: Props) {
  if (!Children.count(children)) {
    return null;
  }

  return (
    <TrackClick
      {...link}
      aria-haspopup={hasSubItems}
      as={DynamicLink}
      className={classnames(
        className,
        'reset-anchor cursor-pointer flex font-sans font-bold items-center px-4 relative focus:text-blue hover:text-blue transition-color uppercase',
        `text-${color}`,
        {
          [`focus:text-${color}-active hover:text-${color}-active`]: !!color,
        },
        { 'navigation-arrow': hasSubItems },
        { 'navigation-arrow-active': isActive && hasSubItems },
      )}
      data-testid="NavigationLarge-item-link"
      style={{ fontSize: '0.8125rem' }}
    >
      {children}
    </TrackClick>
  );
}
